import { capitalize } from 'utils/helpers';

const capitalizedTranslation = ({ translation }) => capitalize(translation);
export default capitalizedTranslation;
